import { IContainerReactRenderer, IRendererResult } from './IContainerReactRenderer';
import { UnknownContainer } from '../../model/containers/UnknownContainer';
import { IConversationRun } from '../../model/ConversationRun';

export class UnknownContainerRenderer implements IContainerReactRenderer<UnknownContainer> {
    render(_run: IConversationRun, _container: UnknownContainer): IRendererResult {
        return {}; // Do not crash the view
    }
}
